import { PropertyInquiryDto } from '@tallo/investor/property';
import { RentStage } from '@tallo/property';

/** Whether an inquiry belongs under a filter chip */
export type InquiryFilter = (inquiry: PropertyInquiryDto) => boolean;

/** How a filter orders its inquiries, when it doesn't keep the list's own order */
export type InquiryOrder = (a: PropertyInquiryDto, b: PropertyInquiryDto) => number;

export const byStages =
  (...stages: RentStage[]): InquiryFilter =>
  (inquiry) =>
    stages.includes(inquiry.stage);
